<template>
  <div
    class="my-components--icon-card"
    :class="{ sticky: sticky }"
    @click="toggleSticky"
    :style="{
      margin: '10px auto 20px auto',
      width: cardWidth || '100%',
    }"
  >
    <div class="my-components--icon-card--menu" v-if="menu">
      <button
        v-for="button in Object.keys(menu)"
        @click.stop="() => menu[button].action(data)"
        :key="button"
        :style="{
          'background-color': `${menu[button].color}`,
        }"
      >
        <span>
          <font-awesome-icon :icon="menu[button].icon" />
        </span>
      </button>
    </div>
    <div
      :style="{
        'background-color': color || 'inherit',
        'width': `${this.sideWidth}px`
      }"
    >
      <span v-if="icon && !isBreak">{{ icon }}</span>
      <span class="strong" v-else-if="faIcon && !isBreak">
        <font-awesome-icon :icon="faIcon" />
      </span>
    </div>
    <span
      :style="{
        'width': `calc(100% - ${this.sideWidth}px)`
      }"
    >
      <span
        v-for="(key, index) in useDisplayKeys"
        :style="computedCardStyles(key, index, data[key])"
        :key="index"
        :class="{
          altRow: altRows && altRows[key],
          sep: key === 'sep' && data[key] === 'sep',
          'my-card-slot': data[key] === 'my-card-slot'
        }"
      >
        <slot
            v-if="data[key] === 'my-card-slot'"
            :name='key'
        />
        <strong
          v-if="
            data[key] !== 'my-card-slot' &&
            (!hideLabels ||
            (forceShowLabels &&
              forceShowLabels.includes(key) &&
              !(key === 'sep' && data[key] === 'sep')))
          "
        >
          {{ key }}
        </strong>
        <span v-if="
            data[key] !== 'my-card-slot' &&
            !(key === 'sep' && data[key] === 'sep')
        ">
            {{ data[key] }}
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "MyIconCard",
  props: [
    "data",
    "icon",
    "faIcon",
    "displayKeys",
    "color",
    "rows",
    "altRows",
    "menu",
    "hideLabels",
    "forceShowLabels",
    "seps",
    "cardWidth",
    "applyStyles",
    "hideActiveState",
    "widthBreak"
  ],
  data: () => ({
    sticky: false,
    pageWidth: 1200
  }),
  computed: {
    useDisplayKeys: function () {
      return this.displayKeys || Object.keys(this.data)
    },
    useWidthBreak: function () {
      return this.widthBreak || 600
    },
    sideWidth: function () {
      return this.isBreak ? 10 : 70
    },
    isBreak: function () {
      return this.pageWidth < this.useWidthBreak
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.updatePageSize)
    this.updatePageSize()
  },
  destroyed: function () {
    window.removeEventListener('resize', this.updatePageSize)
  },
  methods: {
    updatePageSize() {
      const width = window.innerWidth
      if (width !== this.pageWidth) {
        this.pageWidth = width
      }
    },
    computedCardStyles(key, index, data) {
      let calcStyles = {};
      if (data !== 'my-card-slot') {
          calcStyles.width =
          (key === "sep" && this.data[key] === "sep")
            ? "100%"
              : this.altRows && this.altRows[key]
              ? `${this.altRows[key]}%`
                : this.rows
                ? this.rows === 1 ? '100%'
                  : `${100 / (this.isBreak ? 2 : this.rows)}%`
                    : "100%"
      }
      if (this.applyStyles) {
        calcStyles = {
          ...calcStyles,
          ...this.applyStyles({ key, index, data, sticky: this.sticky }),
        };
      }
      return calcStyles;
    },
    toggleSticky: function () {
      !this.hideActiveState && (this.sticky = !this.sticky)
    },
  },
};
</script>

<style lang='scss' scoped>
.my-components--icon-card {
  display: flex;
  flex-direction: row;
  background-color: #fff;
  width: 100%;
  color: rgb(88, 88, 88);
  border-radius: 5px;
  margin-bottom: 13px;
  position: relative;
  .my-card-slot {
    width: 100%;
  }
  .sep {
    height: 1px;
    padding: 0;
    background-color: #d9d9d9;
    height: 1px;
    margin-bottom: 18px;
  }
  & > div {
    border-radius: 5px 0 0 5px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
    span {
      font-size: 2rem;
      opacity: 0.5;
    }
  }
  & > span {
    display: flex;
    padding: 10px;
    margin: 0 auto;
    justify-content: space-between; 
    flex-wrap: wrap;
    span {
      width: calc(100% / 4);
      padding-bottom: 10px;
      &.altRow {
        background-color: #f9f9f9;
        border-radius: 5px;
        padding: 8px;
        margin-top: 4px;
        margin-bottom: 10px;
      }
      & strong {
        font-weight: bold;
        width: 100%;
        display: block;
        padding-bottom: 6px;
      }
    }
  }
  .my-components--icon-card--menu {
    $inner-height: 50px;
    background-color: transparent;
    position: absolute;
    width: auto;
    max-width: 0;
    overflow: hidden;
    top: 15px;
    right: 0px;
    transition: all 0.3s;
    padding-right: 0;
    & > button {
      display: flex;
      margin-right: 10px;
      height: calc(#{$inner-height} + 13px);
      width: calc(#{$inner-height} + 13px);
      border-radius: 50%;
      transition: all 0.3s;
      justify-content: center;
      align-items: center;
      border: none;
      svg {
        width: calc(#{$inner-height} - 23px);
      }
      span {
        background-color: rgba(0, 0, 0, 0.5);
        height: $inner-height;
        width: $inner-height;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        transition: all 0.2s;
      }
      &:hover {
        & span {
          background-color: rgba(0, 0, 0, 1);
        }
      }
    }
  }
  &:hover .my-components--icon-card--menu,
  &.sticky .my-components--icon-card--menu {
    max-width: 100%;
  }
  &.sticky {
    color: #000;
    border-radius: 0;
    background-color: #c6eed1;
    box-shadow: inset 0 0 200px #cbffd9, 0 0 0 2px #a3ecb6;
    & > div {
      border-radius: 0;
    }
    .my-components--icon-card--menu {
      $inner-height-small: 35px;
      max-width: 100%;
      background-color: #c6eed1;
      padding: 4px 2px;
      right: -2px;
      top: -55px;
      border-radius: 20px;
      box-shadow: inset 0 0 2px #fff, 0 0 6px rgba(3, 3, 3, 0.233);
      & > button {
        margin: 0 5px;
        height: calc(#{$inner-height-small} + 7px);
        width: calc(#{$inner-height-small} + 7px);
        border-radius: 50%;
        font-size: 10px;
        border: 1px solid rgb(90, 204, 75);
        svg {
          width: calc(#{$inner-height-small} - 15px);
        }
        span {
          height: $inner-height-small;
          width: $inner-height-small;
        }
        &:hover {
          & span {
            background-color: rgba(0, 0, 0, 1);
          }
        }
      }
    }
  }
}
</style>